// extracted by mini-css-extract-plugin
module.exports = {"common":"index_common__1YDP0","header":"index_header__dBCsC","body":"index_body__wFZjH"};